//该文件用于创建Vuex中最为核心的store
import Vue from 'vue'
//引入Vuex
import Vuex from 'vuex'
import commonDescription from './commonDescription'
import global from './global'
import guangshanruidu from './guangshanruidu'
import jiezhipinlv from './jiezhipinlv'
import youbiaoruidu from './youbiaoruidu'
import wenliganzhi from './wenliganzhi'
import wenliyundong from './wenliyundong'
import guangshanyundong from './guangshanyundong'
import zaoyinpaichu from './zaoyinpaichu'
import sejue from './sejue'
//应用Vuex插件
Vue.use(Vuex)

//创建并暴露store
export default new Vuex.Store({
	modules:{
        commonDescription,
        global,
        guangshanruidu,
        jiezhipinlv,
        youbiaoruidu,
        wenliganzhi,
        wenliyundong,
        guangshanyundong,
        zaoyinpaichu,
        sejue
    }
})